import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

// Derives image host from API URL - strips /api suffix
// e.g. https://yourdomain.com/api &#8594; https://yourdomain.com
export const IMAGE_BASE_URL = API_BASE_URL.replace(/\/api\/?$/, '');

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

// Automatically attach JWT token from sessionStorage on every request
api.interceptors.request.use(config => {
  const token = sessionStorage.getItem('adminToken');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export const setDbSwitchInProgress = () => {};

export const fetchMenu = async () => {
  const { data } = await api.get('/menu');
  return data;
};

export const fetchContent = async (section) => {
  const { data } = await api.get(`/content/${section}`);
  return data;
};

export const fetchProducts = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const { data } = await api.get(`/products${query ? '?' + query : ''}`);
  return data;
};

export const fetchTestimonials = async () => {
  const { data } = await api.get('/testimonials');
  return data;
};

export const fetchBranding = async () => {
  const { data } = await api.get('/branding');
  return data;
};

export const fetchSlides = async () => {
  const { data } = await api.get('/slides');
  return data;
};

export const fetchReviews = async () => {
  const { data } = await api.get('/reviews');
  return data;
};

export const submitContact = async (formData) => {
  const { data } = await api.post('/contact', formData);
  return data;
};

export const uploadImage = async (file) => {
  const form = new FormData();
  form.append('image', file);
  const token = sessionStorage.getItem('adminToken');
  const { data } = await axios.post(`${API_BASE_URL}/upload`, form, {
    headers: {
      ...(token ? { 'Authorization': `Bearer ${token}` } : {})
    }
  });
  return data.url;
};

export const getImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http')) return url;
  return `${IMAGE_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

export default api;
